const getQueryStringFromURL = (url, queryString) => {
  const regex = new RegExp(`${queryString}=([^&]*)`)
  return decodeURI(url.match(regex)[1])
}

export default getQueryStringFromURL



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/get-query-string-value/index.js